import { Box, Typography } from "@mui/material";
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import { DataGrid } from "@mui/x-data-grid";
import { formatCurrency } from "../../../helpers/financialHelpers";

const InvoiceShowBillingItems = ({ invoice }) => {
    const columns =
        [
            { field: 'itemName', headerName: 'Item', flex: 2 },
            { field: 'itemValue', headerName: 'Preço', flex: 1 },
            { field: 'itemQuantity', headerName: 'Quantidade', flex: 1 },
            { field: 'itemTotalValue', headerName: 'Total', flex: 1 },
        ];
    const rowsParts =
        [
            ...(invoice?.invoice_parts?.map(part => ({
                id: `part-${part.id}`,
                type: "part",
                itemId: part.part_id,
                itemName: part.name,
                itemValue: part.unit_value == null || part.unit_value === 0 ? '-' : `R$ ${formatCurrency(part.unit_value)}`,
                itemQuantity: part.quantity || '-',
                itemTotalValue: `R$ ${formatCurrency(part.subtotal_value)}` || '-',
            })) || []),
        ];
    const rowsServices = [
        ...(invoice?.invoice_services?.map(service => ({
            id: `service-${service.id}`,
            type: "service",
            itemId: service.service_id,
            itemName: service.name,
            itemValue: service.unit_value == null || service.unit_value === 0 ? '-' : `R$ ${formatCurrency(service.unit_value)}`,
            itemQuantity: service.quantity || '-',
            itemTotalValue: `R$ ${formatCurrency(service.subtotal_value)}` || '-',
        })) || []),
    ]
    const handleRowClick = (row) => {
        if (!row.itemId) return;
        const urlMap = {
            part: `/parts/${row.itemId}/edit`,
            service: `/services/${row.itemId}/edit`,
        };

        const url = urlMap[row.type];
        if (url) window.open(url, "_blank");
    };
    return (
        <>
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                    <ReceiptRoundedIcon sx={{ color: 'primary.main', mr: 1 }} />
                    <Typography variant='h6' sx={{ color: 'primary.main' }}>Itens na cobrança</Typography>
                </Box>
                {rowsParts.length > 0 && (
                    <Box>
                        <Box>
                            <Typography variant='h7'> Peças e Materiais</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', marginBottom: '2rem' }}>
                            <DataGrid
                                columns={columns}
                                rows={rowsParts}
                                hideFooter
                                disableColumnMenu
                                disableSelectionOnClick
                                loading={!invoice}
                                onRowClick={(params) => handleRowClick(params.row)}
                                sx={{
                                    border: 'none',
                                    '& .MuiDataGrid-columnHeader': {
                                        px: '2rem',
                                    },
                                    '& .MuiDataGrid-cell': {
                                        borderRight: 'none',
                                        px: '2rem',
                                    },
                                    '& .MuiDataGrid-columnSeparator': {
                                        display: 'none',
                                    },
                                    '& .MuiDataGrid-row': {
                                        borderBottom: '1px solid theme.palette.divider',
                                        cursor: 'pointer',
                                    },

                                    '.MuiDataGrid-columnHeaderTitle': {
                                        fontWeight: 'bold',
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                )}
                {rowsServices.length > 0 && (
                    <>
                        <Box>
                            <Typography variant='h7'> Serviços</Typography>
                        </Box>
                        <Box>
                            <DataGrid
                                columns={columns}
                                rows={rowsServices}
                                hideFooter
                                disableColumnMenu
                                disableSelectionOnClick
                                loading={!invoice}
                                onRowClick={(params) => handleRowClick(params.row)}
                                sx={{
                                    border: 'none',
                                    '& .MuiDataGrid-columnHeader': {
                                        px: '2rem',
                                    },
                                    '& .MuiDataGrid-cell': {
                                        borderRight: 'none',
                                        px: '2rem',
                                    },
                                    '& .MuiDataGrid-columnSeparator': {
                                        display: 'none',
                                    },
                                    '& .MuiDataGrid-row': {
                                        borderBottom: '1px solid theme.palette.divider',
                                        cursor: 'pointer',
                                    },

                                    '.MuiDataGrid-columnHeaderTitle': {
                                        fontWeight: 'bold',
                                    },
                                }}
                            />
                        </Box>
                    </>
                )}
            </Box>
        </>
    )
}

export default InvoiceShowBillingItems;